/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CommentRectPlusIcon16Light } from './CommentRectPlusIcon16Light';
import { CommentRectPlusIcon16Regular } from './CommentRectPlusIcon16Regular';
import { CommentRectPlusIcon16Solid } from './CommentRectPlusIcon16Solid';
import { CommentRectPlusIcon20Light } from './CommentRectPlusIcon20Light';
import { CommentRectPlusIcon20Regular } from './CommentRectPlusIcon20Regular';
import { CommentRectPlusIcon20Solid } from './CommentRectPlusIcon20Solid';
import { CommentRectPlusIcon24Regular } from './CommentRectPlusIcon24Regular';
import { CommentRectPlusIcon24Solid } from './CommentRectPlusIcon24Solid';
import { CommentRectPlusIcon32Regular } from './CommentRectPlusIcon32Regular';
import { CommentRectPlusIcon64Regular } from './CommentRectPlusIcon64Regular';
var sizes = {
    16: {
        light: CommentRectPlusIcon16Light,
        regular: CommentRectPlusIcon16Regular,
        solid: CommentRectPlusIcon16Solid,
    },
    20: {
        light: CommentRectPlusIcon20Light,
        regular: CommentRectPlusIcon20Regular,
        solid: CommentRectPlusIcon20Solid,
    },
    24: {
        regular: CommentRectPlusIcon24Regular,
        solid: CommentRectPlusIcon24Solid,
    },
    32: {
        regular: CommentRectPlusIcon32Regular,
    },
    64: {
        regular: CommentRectPlusIcon64Regular,
    },
};
export var CommentRectPlusIcon = forwardRef('CommentRectPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
